import { Component, inject, Input } from '@angular/core';
import { catchError, of, map as rxMap } from 'rxjs';

import { Models } from '$models';
import { SettingsService } from '$settings';
import { UiStateService } from '$ui';
import { AsyncPipe } from '@angular/common';
import { ModalWizardModels } from 'src/app/components/modal-wizard/shared/models/modal-wizard.model';
import { BidTermsOfServiceComponent } from '../../components/bid-terms-of-service/bid-terms-of-service.component';
import { BiddingService } from '../../shared/services/bidding.service';
import { BiddingStoreService } from '../../store/bidding.store';

@Component({
  selector: 'app-bid-terms-of-service-step-content',
  template: `
    <div class="bid-terms-of-service-step-content">
      <app-bid-terms-of-service [user]="user$ | async" [property]="propertyDetails$ | async" />
    </div>
  `,

  imports: [BidTermsOfServiceComponent, AsyncPipe],
})
export class BidTermsOfServiceStepContentComponent implements ModalWizardModels.StepContent {
  private settings = inject(SettingsService);
  private biddingStore = inject(BiddingStoreService);
  private bidding = inject(BiddingService);
  private ui = inject(UiStateService);
  @Input() stepId = 'bid-terms-of-service-step';

  user: Models.LoginResponse | null = null;
  propertyDetails: Models.PropertyDetailsResponse | null = null;

  user$ = this.settings.user$.pipe(
    rxMap(user => {
      this.user = user;
      return user;
    }),
    catchError(() => {
      this.user = null;
      return of(null);
    }),
  );

  propertyDetails$ = this.biddingStore.propertyDetails.state$.pipe(
    rxMap(state => {
      this.propertyDetails = state.data;
      return state.data;
    }),
    catchError(() => {
      this.propertyDetails = null;
      return of(null);
    }),
  );

  canEntry(args: ModalWizardModels.StepValidationArgs) {
    return true;
  }

  canExit(args: ModalWizardModels.StepValidationArgs) {
    // Update UI state with terms of service that was agreed by user
    if (this.user && this.propertyDetails) {
      this.bidding.acceptDisclosure({ ITEM_ID: this.propertyDetails.ITEM_ID }).subscribe();
    }
    return true;
  }
}
